// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__16LF-","title":"ClientReferral_title__de2PR","itemText":"ClientReferral_itemText__2gG4v"};